import useApi from '../api';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import queryConfig from '../util/queryConfig';
import Throbber from '../components/throbber/Throbber';
import Error from '../components/error/Error';
import { QueryKey } from '../constants/queryKey';
import Interactions from '../components/interactions/Interactions';

const InteractionsView = () => {
    const { getScenarios } = useApi();
    const [scenario, setScenario] = useState('');
    const { isLoading, error, data } = useQuery([QueryKey.Scenarios], async () => {
        const response = await getScenarios();
        return response.data;
    }, queryConfig);

    useEffect(() => {
        if (!data?.scenarios.length) {
            return;
        }

        setScenario(data.scenarios[0].scenario_id);
    }, [data]);

    const onFilterChange = (e) => {
        setScenario(e.target.value);
    }

    return (
        <div className="view">
            {data?.scenarios?.length ? (
                <div className="filters">
                    <select
                        name="scenario"
                        id="scenario"
                        value={scenario}
                        onChange={onFilterChange}
                    >
                        {data.scenarios.map((scenario) => (
                            <option value={scenario.scenario_id} key={scenario.scenario_id}>{scenario.name}</option>
                        ))}
                    </select>
                </div>
            ) : null}

            <h1 className="heading">Interactions</h1>

            { isLoading ? (
                <Throbber title="Loading scenarios"/>
            ) : error ? (
                <Error msg="Something went wrong loading scenarios. Please try again later."/>
            ) : data?.scenarios?.length ? (
                <Interactions scenario={scenario} />
            ) : (
                <div>No scenarios available yet.</div>
            )}
        </div>
    )
};

export default InteractionsView;
